import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {path: '/', name: 'main', component: () => import('../pages/MainPage.vue')},
  {path: '/treatment', name: 'treatment', component: () => import('../pages/TreatmentPage.vue')},
  {path: '/spa', name: 'spa', component: () => import('../pages/SpaPage.vue')},
  {path: '/leisure', name: 'leisure', component: () => import('../pages/LeisurePage.vue')},
  {path: '/rooms/:selectedRoom', component: () => import('../pages/RoomsPage.vue'), props:true},
  {path: '/rooms', name: 'rooms', component: () => import('../pages/RoomsPage.vue')},
  {path: '/promotions', name: 'promotions', component: () => import('../pages/PromotionsPage.vue')},
  {path: '/contacts', name: 'contacts', component: () => import('../pages/ContactsPage.vue')},
  {path: '/personal-data-policy', name: 'personal-data-policy', component: () => import('../pages/PersonalDataPolicyPage.vue')},
  {path: '/personal-data-consent', name: 'personal-data-consent', component: () => import('../pages/PersonalDataConsentPage.vue')},
  {path: '/cookie-policy', name: 'cookie-policy', component: () => import('../pages/CookiePolicyPage.vue')},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  store.commit('updateRoute',to.path)
  if (to.path === '/promotions' && !store.state.promoIsActive) {
    return '/'
  }
})

router.afterEach((to,from)=>{

  let mainTitle ='САНАТОРИЙ ЭЛИТА - КИСЛОВОДСК - ОФИЦИАЛЬНЫЙ САЙТ'
  let titles = {
    '/':'ГЛАВНАЯ СТРАНИЦА',
    '/treatment':'ГЛАВНАЯ СТРАНИЦА', '/treatment/':'ЛЕЧЕНИЕ И ПУТЕВКМ',
    '/spa':'СПА-КОМПЛЕКС', '/spa/':'СПА-КОМПЛЕКС',
    '/leisure/':'ПИТАНИЕ И ДОСУГ', '/leisure':'ПИТАНИЕ И ДОСУГ',
    '/rooms':'НОМЕРА И ЦЕНЫ', '/rooms/':'НОМЕРА И ЦЕНЫ',
    '/rooms/standard':'НОМЕРА И ЦЕНЫ', '/rooms/standard/':'НОМЕРА И ЦЕНЫ',
    '/rooms/standardTrio':'НОМЕРА И ЦЕНЫ', '/rooms/standardTrio/':'НОМЕРА И ЦЕНЫ',
    '/rooms/comfort':'НОМЕРА И ЦЕНЫ', '/rooms/comfort/':'НОМЕРА И ЦЕНЫ',
    '/rooms/comfortTWIN':'НОМЕРА И ЦЕНЫ', '/rooms/comfortTWIN/':'НОМЕРА И ЦЕНЫ',
    '/rooms/comfortDBL':'НОМЕРА И ЦЕНЫ', '/rooms/comfortDBL/':'НОМЕРА И ЦЕНЫ',
    '/rooms/familyLux':'НОМЕРА И ЦЕНЫ', '/rooms/familyLux/':'НОМЕРА И ЦЕНЫ',
    '/rooms/studio':'НОМЕРА И ЦЕНЫ','/rooms/studio/':'НОМЕРА И ЦЕНЫ',
    '/rooms/lux':'НОМЕРА И ЦЕНЫ', '/rooms/lux/':'НОМЕРА И ЦЕНЫ',
    '/promotions':'АКЦИИ', '/promotions/':'АКЦИИ',
    '/contacts':'КОНТАКТЫ', '/contacts/':'КОНТАКТЫ',
    '/personal-data-policy':'ПОЛИТИКА ПД', '/personal-data-policy/':'ПОЛИТИКА ПД',
    '/personal-data-consent':'СОГЛАСИЕ НА ПД', '/personal-data-consent/':'СОГЛАСИЕ НА ПД',
    '/cookie-policy':'ПОЛИТИКА COOKIES', '/cookie-policy/':'ПОЛИТИКА COOKIES',
  }


  document.title = mainTitle+'-'+titles[to.path]


  setTimeout(()=> {
    if((to.path !=='/' && to.path!==from.path) || to.path ==='/' && from.path!=='/' || (to.path!=='/'&& from.path!=='/') & to.path===from.path ||  (to.path ==='/' && from.path=='/' && store.state.screen.scrollY>40)){
      let scroll = document.getElementById('contentStart').offsetTop
      if(store.state.screen.device==='mobile'){scroll=scroll-store.state.ui.size.mobileNav}
      document.getElementById('showContent').scrollTo({top: scroll,behavior:'smooth'})
    }

  },400)


})

  export default router
